import globals from "@homer.core/globals";
import page from "@homer.core/page";
import module from "@homer.core/module";
import _whenImages from "@homer.core/when.images";
import resolveItemtype from "@homer.utility/itemtype.resolve";
import { name } from "../../package.json" with { type: "json" };

const whenImages = Promise.resolve(_whenImages);
const html = document.documentElement;
const abortReason = `${name}/observer/pagetype`;
let pendingRequest;
let generation = 0;

const abortPending = () => {
    if (pendingRequest) {
        pendingRequest.abort(abortReason);
        pendingRequest = null;
    }
};

const resolve = (node) => {
    const pkg = resolveItemtype(node);

    if (module.resolve(pkg)) {
        const currentGeneration = ++generation;

        // Ignore stale page-type resolutions that were queued before images settled.
        void whenImages.then(() => {
            if (currentGeneration !== generation) {
                return;
            }

            abortPending();

            const request = globals.demand.request(pkg);
            const activation = request.then(
                ([Page]) => {
                    // Fragment replacement invalidates the page owner before the html itemtype changes.
                    if (currentGeneration !== generation) {
                        return;
                    }

                    return Page.obtain(html);
                },
                (error) => {
                    // Aborting a superseded request is expected; current request failures remain globally visible.
                    if (currentGeneration === generation) {
                        throw error;
                    }
                },
            );

            pendingRequest = request;

            void activation.finally(() => {
                if (pendingRequest === request) {
                    pendingRequest = null;
                }
            });
        });
    }
};

page.on("intent:update", () => {
    // Invalidate pending activation synchronously before any fragment root is replaced.
    generation++;
    abortPending();
});

page.on("change", () => {
    resolve(html);
});

resolve(html);
